import { CSSProperties, FC, PropsWithChildren } from 'react';
import { useAnimatedHeight } from '../../../util/hooks';

type Props = {
  duration?: number,
  className?: string,
  style?: CSSProperties,
}

// The wrapper form of useAnimatedHeight, for callers that cannot hold a hook — the phone-log modal
// lives in a class component. Renders one plain box; give it the layout you need through style.
const AnimatedHeight: FC<PropsWithChildren<Props>> = ({ duration, className, style, children }) => {
  const attach = useAnimatedHeight<HTMLDivElement>(duration);

  return (
    <div ref={attach} className={className} style={style}>
      {children}
    </div>
  );
};

export default AnimatedHeight;
